import React, { useEffect, useState } from "react";
import { Box } from "ui-components";
import isFunction from "lodash/isFunction";
import Spinner, { styles } from "components/Spinner";
import { activateZendeskApp } from "utils/helpers";

const ZendeskWidget = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initWidget = setInterval(() => {
      if (loading && isFunction(window.activateZendesk)) {
        clearInterval(initWidget);
        setLoading(false);
        activateZendeskApp();
      }
    }, 1000);

    if (!loading) {
      clearInterval(initWidget);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={loading ? "loading" : ""} id="zendesk-app">
      {loading && <Spinner sx={styles.fullPage} />}
    </Box>
  );
};

export default ZendeskWidget;
